export default function Footer() {
  const currentYear = new Date().getFullYear();

  const navigation = [
    'Como Funciona',
    'Benefícios',
    'Parceiros',
    'Depoimentos',
    'Blog',
    'FAQ'
  ];

  const contact = [
    { icon: 'ri-phone-line', text: '(11) 3000-0000' },
    { icon: 'ri-mail-line', text: 'contato@vitauni.com.br' },
    // { icon: 'ri-whatsapp-line', text: '(11) 99999-9999', highlight: true }, // WhatsApp — desativado temporariamente
  ];

  const social = [
    { icon: 'ri-instagram-line', url: 'https://www.instagram.com/vitauni.oficial/' },
    { icon: 'ri-facebook-line', url: 'https://www.facebook.com/profile.php?id=61577555763478' },
  ];

  return (
    <footer className="bg-gradient-to-br from-[#0A1628] to-[#1A0B2E] text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img 
              src="/img/logo.png"
              alt="VitaUni"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-300 leading-relaxed mb-8 max-w-md">
              Saúde acessível para todos. Descontos reais em consultas, exames e procedimentos. Cuide de você sem pesar no bolso.
            </p>
            <div className="flex gap-4">
              {social.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-gradient-to-r hover:from-[#00A8E8] hover:to-[#E91E63] hover:border-transparent transition-all cursor-pointer"
                >
                  <i className={`${item.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6">Navegação</h3>
            <ul className="space-y-3">
              {navigation.map((item, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato — desativado temporariamente
          <div>
            <h4 className="font-bold text-gray-800 mb-4 text-lg">Contato</h4>
            <div className="space-y-3">
              <a href="tel:+5555997266310" className="flex items-center gap-3 text-gray-600 hover:text-[#00A8E8] transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl w-5 h-5 flex items-center justify-center"></i>
                <span>(55) 99726-6310</span>
              </a>
            </div>
          </div>
          */}
        </div>

        {/* Company Information */}
        <div className="bg-white/5 rounded-2xl p-6 mb-8 border border-white/10">
          <div className="grid md:grid-cols-3 gap-6 text-sm">
            <div>
              <div className="text-gray-400 mb-1">Razão Social</div>
              <div className="text-white font-semibold">TECHNOVITA SOLUCOES LTDA</div>
            </div>
            <div>
              <div className="text-gray-400 mb-1">CNPJ</div>
              <div className="text-white font-semibold">61.705.453/0001-08</div>
            </div>
            <div>
              <div className="text-gray-400 mb-1">Endereço</div>
              <div className="text-white font-semibold">R APARICIO MARIENSE, 2070 - SALA 01</div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <div>
            © {currentYear} VitaUni. Todos os direitos reservados.
          </div>
          <div className="flex flex-wrap gap-6">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Termos de Uso</a>
            <span>•</span>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Política de Privacidade</a>
            <span>•</span>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">LGPD</a>
          </div>
        </div>
      </div>
    </footer>
  );
}